// 5일 단위로 캐싱 적용
const ApplyDateQueryString = url => `${url}?date=${(new Date()).getDate() % 5}`

const ConvertURL = url => {
    if (typeof url === 'string') return ApplyDateQueryString(url)
    return ''
}

const ConvertURLToSmallURL = url => {
    if (typeof url !== 'string' || (!url.toLowerCase().includes('cut') && !url.toLowerCase().includes('result'))) return url

    const index = url.lastIndexOf('.')
    return ConvertURL(`${url.substring(0, index)}_small${url.substring(index, url.length)}`)
}

const GetRepresentedTemplates = (templates, lang, keys = [ '9:16', '1:1', '16:9', '4:5', 'Title', 'End' ]) => {
    if (!Array.isArray(templates)) return null

    const SearchTemplates = (item, lang = null) => {
        for (let i=0; i<keys.length; i++) {
            const key = keys[i]
            if (item[key]) {
                if (!lang || item[key].support_lang[lang]) return item[key]
            }
        }
        return null
    }

    return templates.map(group => {
        const { date, item } = group

        // 1차로 support_lang 지원하는 템플릿 중 Filter.
        // 만약 없을경우 support_lang 조건 무시하고 그냥 가져옴.
        const template = SearchTemplates(item, lang) || SearchTemplates(item)

        template.date = date
        template.key = template.groupKey || template.ratio

        return template
    })
}

const GetLanguageObject = (data, language) => {
    if (data[language]) return data[language]
    if (data['en']) return data['en']
    return null
}

const TemplateHelper = {
    ConvertURLToSmallURL,
    GetRepresentedTemplates,
    
    getName: (data, language) => {
        if (data.default_lang === language) return data.name

        if (language && data.name_lang) {
            const name = GetLanguageObject(data.name_lang, language)
            if (name) return name
        }
        return data.name
    },
    getContent: (data, language) => {
        if (language && data.contentsObj) {
            const content = GetLanguageObject(data.contentsObj, language)
            if (content) return content
            else if (data.default_lang && data.contentsObj[data.default_lang]) return data.contentsObj[data.default_lang]
        }
        return ""
    },
    getPreviewVideo: (data, language) => {
        if (data.default_lang === language) return ConvertURL(data.previewURL)

        if (language && data.previewURL_lang) {
            const video = GetLanguageObject(data.previewURL_lang, language)
            if (video) return ConvertURL(video)
        }
        return ConvertURL(data.previewURL)
    },
    getPreviewImage: (scene, language) => {
        if (language && scene.Preview_lang) {
            if (scene.Preview_lang[language]) return ConvertURL(scene.Preview_lang[language])
        }
        return ConvertURL(scene.Preview)
    },
    getThumbnailImage: (data, language, isSmall = false) => {
        let url = data.thumnailURL
        if (data.default_lang === language) return ConvertURL(isSmall ? ConvertURLToSmallURL(url) : url)
        
        if (language && data.thumnailURL_lang) {
            const thumbnail = GetLanguageObject(data.thumnailURL_lang, language)
            if (thumbnail) url = ConvertURL(thumbnail)
        }
        return ConvertURL(isSmall ? ConvertURLToSmallURL(url) : url)
    }
}
export default TemplateHelper;
